// Destino do antigo "/booking" no fluxo único de pedidos (10/10/2026).
// O fluxo de marcações (agendamentos) só teve 4 registos, todos de teste: todos
// os botões "Agendar" passam a abrir o pedido (/pedir). Um prestador concreto
// vai pelo link pessoal dele (?p=), para o pedido lhe chegar primeiro; um
// serviço concreto entra como texto inicial (a categoria é sugerida a partir dele).

export function destinoPedido(opcoes: { codigoPrestador?: string | null; tituloServico?: string | null; origem?: string }): string {
  const q = new URLSearchParams()
  if (opcoes.codigoPrestador) q.set('p', opcoes.codigoPrestador)
  const titulo = (opcoes.tituloServico ?? '').trim()
  if (titulo) q.set('texto', titulo.slice(0, 200))
  q.set('origem', opcoes.origem || 'booking')
  return `/pedir?${q.toString()}`
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/** Ids do URL antigo (?prestador=<id>&servico=<id>), só se forem UUID válidos. */
export function idsDoBooking(search: string): { prestador: string | null; servico: string | null } {
  const q = new URLSearchParams(search)
  const prestador = q.get('prestador')
  const servico = q.get('servico')
  return {
    prestador: prestador && UUID.test(prestador) ? prestador : null,
    servico: servico && UUID.test(servico) ? servico : null,
  }
}
